import AbstractTransaction from './AbstractTransaction'
import BigNumber from 'bignumber.js'
import { EVENT_DISTRIBUTED_FOR_PARTIALS_V2 } from '@/constants/backend/transaction'
import { Blockchain } from '@/constants/blockchain'
import { CURRENCY_FIELD_BACKEND_ID } from '@/constants/currency'
import { getCurrency } from '@/utils-ts/currencies'

export default class DisputeTransaction extends AbstractTransaction {
  static fromServer(data: LX.TransactionListItem, userId: number) {
    if (data) {
      const job = data.relations.Job || data.relations.GigJob
      const isCustomer = job?.customer_id === userId
      const currency = getCurrency({
        blockchain: +(job.blockchain || Blockchain.Ethereum),
        value: +job.currency,
        field: CURRENCY_FIELD_BACKEND_ID,
      })
      let amount = new BigNumber(0)
      if (data.tx_data) {
        if (isCustomer) {
          if (data.event === EVENT_DISTRIBUTED_FOR_PARTIALS_V2) {
            amount = new BigNumber(data.tx_data.customerPayAmount)
          } else {
            amount =
              typeof data.tx_data.customerAmount === 'object'
                ? new BigNumber(data.tx_data.customerAmount._hex, 16)
                : new BigNumber(data.tx_data.customerAmount)
          }
        } else {
          if (data.event === EVENT_DISTRIBUTED_FOR_PARTIALS_V2) {
            amount = new BigNumber(data.tx_data.freelancerPayAmount)
          } else {
            amount =
              typeof data.tx_data.freelancerAmount === 'object'
                ? new BigNumber(data.tx_data.freelancerAmount._hex, 16)
                : new BigNumber(data.tx_data.freelancerAmount)
          }
        }
      }
      amount = amount.dividedBy(currency?.baseUnits || 1)
      const wallet = isCustomer ? job.customer_wallet : job.freelancer_wallet
      return new DisputeTransaction({
        icon: 'dispute.png',
        title: 'Dispute Resolution',
        wallet: (wallet || '').toLowerCase(),
        amount,
        currency,
        created_at: data.created_at,
        event: data.event,
        tx_id: data.tx_id,
      })
    }
  }
}
